import { render, staticRenderFns } from "./NoteView.vue?vue&type=template&id=f3f3f2ce&scoped=true&"
import script from "./NoteView.vue?vue&type=script&lang=js&"
export * from "./NoteView.vue?vue&type=script&lang=js&"
import style0 from "./NoteView.vue?vue&type=style&index=0&id=f3f3f2ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f3f2ce",
  null
  
)

export default component.exports